// @ts-strict-ignore
import { Checkbox, Text } from '@usealloy/component-library';
import React, { useContext } from 'react';
import styled from 'styled-components';
import { UserContext } from '~/dashboard/context';

// ============================================================
//   TYPES
// ============================================================
export type WorkflowBacktestInputProps = {
  isTestWorkflow: boolean;
  setIsTestWorkflow: React.Dispatch<React.SetStateAction<boolean>>;
};

// ============================================================
//   STYLED DOM ELEMENTS
// ============================================================
const BacktestToggleContainer = styled('div')({
  marginTop: '27px',
});

// ============================================================
//   COMPONENT
// ============================================================
/**
 * A checkbox input to mark a workflow as "testing" or not.
 * Only renders if the current logged in user is an Alloy employee
 */
export const WorkflowBacktestInput: React.FC<WorkflowBacktestInputProps> = ({
  isTestWorkflow,
  setIsTestWorkflow,
}) => {
  const { agent: { isEmployee } } = useContext(UserContext);

  if (!isEmployee) {
    return null;
  }

  return (
    <BacktestToggleContainer>
      <Text weight={700} style={{ marginBottom: 'var(--cl-space-3)' }}>
        Backtesting
      </Text>
      <Checkbox
        label="This workflow will be used for backtesting and evaluations will not be billed"
        checked={isTestWorkflow}
        onChange={e => { setIsTestWorkflow(e.target.checked); }}
      />
    </BacktestToggleContainer>
  );
};
